const commentArr = ['急げば間に合います！', '今がまさに始めどき！','余裕をもって目指せる！']

const date = new Date()
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
let box = 2 //default
if(day <= 15){
  box = 1
}


fetch(`/course/data/seasonal/${year}_${KozaSeq}.csv`)
  .then((response) => response.text())
  .then((text) => {
    let arr = text.split('\n')
    let boxData = []
    let monthData = []
    let targetData = []

    for(let i = 1; i<arr.length; i++){
      let eachData = arr[i].split(',')
      boxData.push(eachData)
    }

    // 各boxDataからmonthが一致した配列データを取得。1box, 2boxの２つのデータを取得
    for(let i = 0; i<boxData.length; i++){
      if(Number(boxData[i][1]) === month) {
        monthData.push(boxData[i])
      }
    }

    if(box === 1) {
      targetData = monthData[0]
    }else {
      targetData = monthData[1]
    }

    const timing = Number(targetData[0]) - 1
    const headText = targetData[3]
    const deadlineNone = targetData[4]
    const deadlineYear = targetData[5]
    const deadlineMonth = targetData[6]
    const deadlineOther = (targetData[7]=='') ? '願書締切' : targetData[7]
    const examYear = targetData[8]
    const examMonth = targetData[9]
    const examOther = targetData[10] == '' ? '試験' : targetData[10]
    const result = targetData[11]
    const bodyText = targetData[12]
    const note = targetData[13]


    // timingが空白だったら以降の処理をしない（長期未材の時など）
    if(timing == -1) {
      return;
    }

    //common code
    const seasonalStep = `<ul class="seasonal__list">
    <li class="seasonal__step"><div class="seasonal__inner seasonal__inner--start">START</div></li>
    <li class="seasonal__arrow"></li>
    <li class="seasonal__step"><div class="seasonal__inner">
    <p class="seasonal__head"><span class="seasonal__year">${deadlineYear}</span><span class="seasonal__month">${deadlineMonth}</span>月</p>
    <p class="seasonal__term">${deadlineOther}</p>
    </div></li>
    <li class="seasonal__arrow"></li>
    <li class="seasonal__step"><div class="seasonal__inner">
    <p class="seasonal__head"><span class="seasonal__year">${examYear}</span><span class="seasonal__month">${examMonth}</span>月</p>
    <p class="seasonal__term ${KozaSeq == 174 ? 'seasonal__term--174' : ''}">${examOther}</p>
    </div></li>
    </ul>`

    const seasonalStepDeadlineNone = `<ul class="seasonal__list">
    <li class="seasonal__step"><div class="seasonal__inner seasonal__inner--start">START</div></li>
    <li class="seasonal__arrow seasonal__arrow--first"></li>
    <li class="seasonal__arrow"></li>
    <li class="seasonal__arrow"></li>
    <li class="seasonal__arrow"></li>
    <li class="seasonal__step"><div class="seasonal__inner">
    <p class="seasonal__head"><span class="seasonal__year">${examYear}</span><span class="seasonal__month">${examMonth}</span>月</p>
    <p class="seasonal__term">${examOther}</p>
    </div></li>
    </ul>`



    // page-top
    if(pageName.indexOf('トップ')>=0){
      //top(head)
      if(timing == 0) {
        let seasonalHtm = `<section class="seasonal">
        <div class="summary-section__inner"><span class="seasonal__mark">今なら</span><h2 class="summary-section__title seasonal__lead">${headText}</h2></div>
        <div class="seasonal__figure">
        <picture class="seasonal__icon">
        <source media="(min-width: 568px)" srcset="/course/common/images/seasonal/isogi_pc.png"><img src="/course/common/images/seasonal/isogi_sp.png" alt="">
        </picture>`
        if(deadlineNone == 1) {
          seasonalHtm += `${seasonalStepDeadlineNone}`
        } else {
          seasonalHtm += `${seasonalStep}`
        }
        seasonalHtm += `<p class="seasonal__item"><a href="/course/data/in_html/${KozaSeq}/schedule/" class="seasonal__link link-unit">詳細はこちら</a></p>
        </div>`
        if(note.length >= 2){
          seasonalHtm += `<p class="seasonal__text seasonal__text--note">${note}</p>`
        }
        seasonalHtm += `</section>`

        const seasonalElm = document.createElement('section')
        const seasonalElmClasses = ['summary-section','summary-section--seasonal-top','unit']
        seasonalElmClasses.forEach((seasonalElmClass) =>{
          seasonalElm.classList.add(seasonalElmClass)
        })
        if(deadlineNone == 1) {
          seasonalElm.classList.add('no-deadline')
        }
        seasonalElm.innerHTML = seasonalHtm
        const summarySection = document.querySelector('.summary-section')
        if(document.querySelector('.seasonal') == null) {
          summarySection.parentNode.insertBefore(seasonalElm, summarySection)
        }
      }


      //top(schedule)
      let seasonalSchedule = `<p class="seasonal__comment">${commentArr[timing]}</p>
      <div class="seasonal__figure">`
      if(deadlineNone == 1) {
        seasonalSchedule += `${seasonalStepDeadlineNone}`
      } else {
        seasonalSchedule += `${seasonalStep}`
      }
      seasonalSchedule += `</div>`

      const allSummarySubsection = document.querySelectorAll('.summary-subsection')
      // for IE
      const summarySubsectionElms = Array.prototype.slice.call(allSummarySubsection,0)
      summarySubsectionElms.forEach((elm) => {
        if(elm.querySelectorAll('.btn-unit__link').length){
          if(elm.querySelector('.btn-unit__link').getAttribute('href').indexOf('/schedule/') >= 0){
            const targetImgArea = elm.querySelector('.summary-subsection__img')
            const targetImgClasses = ['seasonal', 'seasonal--schedule']
            targetImgClasses.forEach((targetImgClass) => {
              targetImgArea.classList.add(targetImgClass)
            })
            if(deadlineNone == 1) {
              targetImgArea.classList.add('no-deadline')
            }
            targetImgArea.innerHTML = seasonalSchedule
          }
        }
      })


      //top(cv)
      const seasonalResult = `<div class="seasonal-balloon__inner">
      <p>今始めれば<strong class="seasonal-balloon__strong">${result}</strong>に合格！</p>
      </div>`
      const bottomCV = document.querySelector('.cv-block:not(.cv-block--top):not(.cv-block--fixed)')
      const balloonElm = document.createElement('div')
      balloonElm.classList.add('seasonal-balloon')
      balloonElm.innerHTML = seasonalResult
      if(document.querySelector('.seasonal-balloon') == null) {
        bottomCV.parentNode.insertBefore(balloonElm, bottomCV)
      }
    }


    // page schedule
    if(pageName.indexOf('スケジュール')>=0 || pageName.indexOf('学習のステップ')>=0){
      //schedule(head)
      let detailHtm = `<h2 class="page-section__title">今なら${headText}</h2>
      <div class="seasonal__figure">`
      if(deadlineNone == 1) {
        detailHtm += `${seasonalStepDeadlineNone}`
      } else {
        detailHtm += `${seasonalStep}`
      }
      detailHtm += `</div>
      <p class="seasonal__text">${bodyText}</p>`
      if(note.length >= 2){
        detailHtm += `<p class="seasonal__text seasonal__text--note">${note}</p>`
      }
      const detailElm = document.createElement('section')
      const detailElmClasses = ['seasonal','seasonal--detail']
      detailElmClasses.forEach((detailElmClass) => {
        detailElm.classList.add(detailElmClass)
      })
      if(deadlineNone == 1) {
        detailElm.classList.add('no-deadline')
      }
      detailElm.innerHTML = detailHtm
      const pageSection = document.querySelector('.page-section')
      pageSection.insertBefore(detailElm, pageSection.firstChild)
    }
  })
  .catch((error) => {
    console.log('There has been a problem with your fetch operation: ', error.message);
  })